<template>
  <div class="manage-main-box">
    <Bread :breadConfig="breadConfig" />
    <div class="eol-container-box">
      <div class="search-all-box">
        <a-form-model layout="inline" ref="ruleForm" :model="form" :rules="rules">
          <a-form-model-item>
            <a-input v-model="form.name" style="width: 140px" class="search-input" placeholder="请输入基地名称"></a-input>
          </a-form-model-item>
          <a-form-model-item>
            <a-input v-model="form.address" style="width: 120px" class="search-input" placeholder="请输入地址"></a-input>
          </a-form-model-item>
          <a-form-model-item prop="category_id">
            <a-select v-model="form.category_id" placeholder="请选择基地分类" style="width: 140px" class="multiple-select" dropdownClassName="multipleDrop">
              <a-select-option value="">请选择基地分类</a-select-option>
              <a-select-option v-for="(item, index) in schoolCategory" :key="`t${index}`" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="course_id">
            <a-select v-model="form.course_id" placeholder="请选择课程" style="width: 160px" class="multiple-select" dropdownClassName="multipleDrop" @change="courseChange">
              <a-select-option value="">请选择课程</a-select-option>
              <a-select-option v-for="(item, index) in schoolTrainCourse" :key="`s${index}`" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item prop="chapter_id">
            <a-select v-model="form.chapter_id" placeholder="请选择章节" style="width: 160px" class="chapter-select" dropdownClassName="chapterDrop">
              <a-select-option value="">{{form.course_id ? '请选择章节' : '请先选择课程'}}</a-select-option>
              <a-select-option v-for="(item, index) in schoolTrainChapter" :key="`c${index}`" :value="item.id">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item>
            <a-button class="search-btn" type="primary" @click="onSearch()">搜索</a-button>
            <a-button class="reset-btn" @click="resetForm()">重置</a-button>
          </a-form-model-item>
        </a-form-model>
      </div>

      <div class="table-all-box">
        <a-table :columns="columns" :data-source="tableData" :bordered="false" size="small" rowKey="id" :pagination="false">
          <template slot="name" slot-scope="text, scope">
            <a class="link-name" :href="scope.url" rel="noopener noreferrer" target="_blank">{{text}}</a>
          </template>
          <template slot="action" slot-scope="row, scope">
            <a-button type="link" style="padding: 0;" @click="visitLink(scope)">访问基地链接</a-button>
          </template>
          <template slot="is_sz" slot-scope="text">
            {{text == 2 ? '是' : '否'}}
          </template>
          <template slot="intro" slot-scope="text, scope">
            <a-popover title="">
              <template slot="content">
                <div class="intro-popover-box" v-html="text"> </div>
              </template>
              <span class="easy-line">{{scope.introTxt}}</span>
            </a-popover>
          </template>
        </a-table>

        <a-pagination class="school-pagination" v-model="page" :total="totalNum" @change="pageChange" show-less-items />
      </div>

    </div>
  </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Bread from "../../../../components/school/Bread.vue";
export default {
  components: {
    Bread,
  },
  data () {
    return {
      breadConfig: [
        { name: "实践资源库" },
        { name: "实践基地" },
      ],
      page: 1,
      size: 10,
      totalNum: 0,
      tableData: [],
      form: {
        name: "",
        address: '',
        category_id: '',
        course_id: '',
        chapter_id: '',
      },
      rules: {
        name: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur",
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur",
          },
        ],
      },
      data: [
        {
          id: "1",
          name: "周恩来邓颖超纪念馆",
          address: '北京市海淀区红枫路1号院',
          type: '党史新中国史教育专题',
          class: "习近平新时代中国特色社会主义思想概论",
          chapter: "第二章",
        },
        {
          id: "2",
          name: "中共中央香山革命纪念地（香山革命纪念馆）",
          address: '北京市海淀区红枫路1号院',
          type: '党史新中国史教育专题',
          class: "习近平新时代中国特色社会主义思想概论",
          chapter: "第二章",
        },
        {
          id: "3",
          name: "中共中央香山革命纪念地（香山革命纪念馆）",
          address: '北京市海淀区红枫路1号院',
          type: '党史新中国史教育专题',
          class: "习近平新时代中国特色社会主义思想概论",
          chapter: "第二章",
        },
      ],
      columns: [
        {
          title: "实践基地名称",
          dataIndex: "name",
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          title: "地址",
          dataIndex: "address",
        },
        {
          title: "省份",
          dataIndex: "province",
          width: '80px',
        },
        {
          title: "城市",
          dataIndex: "city",
          width: '80px',
        },
        {
          title: "介绍",
          dataIndex: "intro",
          scopedSlots: { customRender: 'intro' },
          ellipsis: true,
        },
        // {
        //   title: "是否大思政实践教育基地",
        //   dataIndex: "is_sz",
        //   scopedSlots: { customRender: 'is_sz' },
        //   align: 'center',
        //   width: '110px',
        // },
        {
          title: "基地分类",
          dataIndex: "category_name",
        },
        {
          title: "所属课程",
          dataIndex: "course_name",
        },
        {
          title: "所属章节",
          dataIndex: "chapter_name",
        },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: 'action' },
          align: 'center',
          width: '120px',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      schoolTrainCourse: state => state.resourceLibrary.schoolTrainCourse, // 课程列表 
      schoolTrainChapter: state => state.resourceLibrary.schoolTrainChapter, // 课程章节
      schoolCategory: state => state.resourceLibrary.schoolCategory, // 实验基地/数字展馆 分类列表
    }),
  },
  mounted () {
    this.getSchoolTrainCourse()
    this.getTableList()
    this.getSchoolCategory({ type: 2 })
  },
  methods: {
    ...mapActions(["getCourseStudyHub", 'getSchoolTrainCourse', 'getSchoolTrainChapter', 'getSchoolCategory']),
    ...mapMutations(['setSchoolTrainChapter']),
    getTableList () {
      let params = {
        page: this.page,
        size: this.size,
        name: this.form.name,
        address: this.form.address,
        category_id: this.form.category_id,
        course_id: this.form.course_id,
        chapter_id: this.form.chapter_id,
      };
      this.getCourseStudyHub(params).then((res) => {
        if (res.code == "0000" && res.data) {
          res.data.items && res.data.items.map(item => {
            if (item.intro) {
              item.introTxt = this.introFormat(item.intro)
            }
            return item
          })
          this.tableData = res.data.items;
          this.totalNum = res.data.total;
          // console.log(res.data)
        }
      });
    },
    introFormat (text) {
      return text.replace(/<[^>]+>/g, '');
    },
    onSearch () {
      this.page = 1;
      this.total = 0;
      this.getTableList();
    },
    pageChange (val) {
      this.page = val;
      this.total = 0;
      this.getTableList();
    },
    resetForm () {
      this.$refs.ruleForm.resetFields();
      this.setSchoolTrainChapter({})
      this.onSearch()
    },
    // 课程筛选切换事件
    courseChange (val) {
      this.form.chapter_id = ''
      if (val) {
        this.getSchoolTrainChapter({ course_id: val })
      } else {
        this.setSchoolTrainChapter({})
      }
    },
    visitLink (item) {
      // window.open(item.url, "_blank", 'noopener,noreferrer,resizable')
      window.open('javascript:window.name;', '<script>location.replace("' + item.url + '")<\/script>'); // eslint-disable-line

    }
  },
};
</script>

<style lang="less" scoped>
.link-name {
    font-size: 14px;
    color: #b84b3c;
}
.easy-line {
    width: 150px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
}
</style>

<style lang="less">
.intro-popover-box {
    max-width: 1000px;
}
</style>